import React from 'react';
import {Button} from '@albert-io/atomic';
import {local} from 'lib/StorageUtil';
import {isSafeRedirectPath} from 'lib/isSafeRedirectPath';

import './assets/social-button.scss';

interface Props extends PropsWithChildrenRequired {
  disabled: boolean;
  href: string;
  provider: 'clever' | 'google';
  stayOnCurrentPageAfterAuth?: boolean;
}

export default function SocialButton({
  children,
  disabled,
  href,
  provider,
  stayOnCurrentPageAfterAuth
}: Props) {
  const handleClick = () => {
    if (stayOnCurrentPageAfterAuth) {
      const currentPath = window.location.pathname + window.location.search;
      // Only ever store a same-origin relative path (open-redirect guard on the consuming side).
      if (isSafeRedirectPath(currentPath)) {
        local.set('postLoginRedirect', currentPath);
      }
    }
  };

  return (
    <Button
      as='a'
      href={href}
      color={`vendor-${provider}`}
      className='sso-button'
      disabled={disabled}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
}
